import { getDataFromSessionStorage } from "./helper";

export const getOnFidoSdkTokenAndWorkflowRunId = async applicantId => {
  // call the create applicant endpoint
  const requestBodyWithApplicantId = {
    applicant_id: applicantId,
  };

  const apis = ["sdkToken", "workflowRuns"];

  const apiCallsWithApplicantIdPayload = apis.map(
    api => () =>
      fetch(
        `/api/onfido/${api}?uuid=${
          getDataFromSessionStorage("applicationTokens").uuid
        }`,
        {
          method: "POST",
          headers: {
            Authorization: `${
              getDataFromSessionStorage("applicationTokens").onmoAT
            }`,
          },
          body: JSON.stringify(requestBodyWithApplicantId),
        },
      ),
  );

  try {
    const [generateSdkTokenResponse, generatedWorkflowRunIdResponse] =
      await Promise.all(
        apiCallsWithApplicantIdPayload.map(apiCall => apiCall()),
      );
    const [sdkTokenJson, workflowRunsJson] = await Promise.all([
      generateSdkTokenResponse.json(),
      generatedWorkflowRunIdResponse.json(),
    ]);

    if (generateSdkTokenResponse.ok && generatedWorkflowRunIdResponse.ok) {
      return {
        token: sdkTokenJson?.token,
        workflowRunId: workflowRunsJson?.id,
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error(`Error generating SDK Token`, error);
    return null;
  }
};

export const getOnFidoApplicantId = async (firstName, lastName) => {
  // call the create applicant endpoint
  const applicantIdRequestBody = {
    first_name: firstName,
    last_name: lastName,
  };

  try {
    const applicantIdResponse = await fetch(
      `/api/onfido/applicantId?uuid=${
        getDataFromSessionStorage("applicationTokens").uuid
      }`,
      {
        method: "POST",
        headers: {
          Authorization: `${
            getDataFromSessionStorage("applicationTokens").onmoAT
          }`,
        },
        body: JSON.stringify(applicantIdRequestBody),
      },
    );

    if (applicantIdResponse.ok) {
      const res = await applicantIdResponse.json();
      return res?.id;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

const getOnFidoCheckStatus = async applicantId => {
  // Every 30 seconds, we check the status of the onfido verification. We do this for a maximum of 12 times which is 5 mins.
  const MAX_RETRIES = 10;
  let intervalId;

  let retryCount = 0;

  const checkResult = async () => {
    try {
      const getCheckResponse = await fetch(
        `/api/onfido/checkStatus?uuid=${
          getDataFromSessionStorage("applicationTokens").uuid
        }&applicantId=${applicantId}`,
        {
          method: "GET",
          headers: {
            Authorization: `${
              getDataFromSessionStorage("applicationTokens").onmoAT
            }`,
          },
        },
      );
      let checkObject;
      if (getCheckResponse.ok) {
        try {
          const res = await getCheckResponse.json();
          checkObject = res.checks[0];
        } catch (error) {
          console.log(error);
        }
        if (checkObject?.status === "complete") {
          console.log(`Onfido check status is complete`, checkObject);
          return checkObject.result === "clear";
        } else if (retryCount < MAX_RETRIES) {
          retryCount++;
          await new Promise(resolve => {
            console.debug(`New attempt to get Onfido check status`, retryCount);
            intervalId = setTimeout(resolve, 30000);
          }).then(() => clearInterval(intervalId));
          return checkResult(); // Recursive call for polling from checkStatus()
        } else {
          console.error(
            `Maximum number of retries ${MAX_RETRIES} to get Onfido check status reached`,
          );
          return null;
        }
      } else {
        console.log("error");
        return null;
      }
    } catch (error) {
      console.error("Error checking Onfido check status:", error);
      return null;
    }
  };

  return await checkResult();
};

export const submitAndGetOnFidoCheckStatus = async (applicantId, router) => {
  const createCheckRequestBody = {
    applicant_id: applicantId,
    report_names: ["document", "facial_similarity_photo"],
  };

  try {
    await fetch(
      `/api/onfido/submitCheck?uuid=${
        getDataFromSessionStorage("applicationTokens").uuid
      }`,
      {
        method: "POST",
        headers: {
          Authorization: `${
            getDataFromSessionStorage("applicationTokens").onmoAT
          }`,
        },
        body: JSON.stringify(createCheckRequestBody),
      },
    );
  } catch (error) {
    console.log(
      `Error creating onfido check for propect`,
      error,
      `${getDataFromSessionStorage("applicationTokens").uuid}}`,
    );
    router.push("/500"); //TRY FAILED
  }

  return await getOnFidoCheckStatus(applicantId);
};

export const onFidoInitConfig = {
  useModal: true,
  isModalOpen: true,
  containerId: "onfido-mount",
  customUI: {
    colorBackgroundButtonPrimary: "#FC4C02",
    colorBackgroundButtonPrimaryHover: "#FC4C02",
    colorBorderDocTypeButtonHover: "#FC4C02",
    colorBackgroundLinkHover: "#FC4C02",
    colorInputOutline: "#FC4C02",
    colorBorderLinkUnderline: "#FC4C02",
  },
};
